import { useState } from "react";

import { TFunction, useTranslation } from "@impero-com/common/utils/i18n";
import { TextToolState } from "@impero-com/ui";
import { Row } from "@tanstack/react-table";

import { TActTableRow } from "api/generated/model";

interface UseArchiveUtilsProps {
    selectedRows: Row<TActTableRow>[];
}

export function useArchiveUtils({ selectedRows }: UseArchiveUtilsProps) {
    const { t } = useTranslation();
    const [archiveModalOpened, setArchiveModalOpened] = useState(false);

    const hasSelection = selectedRows.length > 0;
    const hasArchivedSelection = selectedRows.some(
        (row) => row.original.archived
    );
    const archiveToolState: TextToolState = computeArchiveToolState(
        t,
        hasSelection,
        hasArchivedSelection
    );

    return {
        archiveToolState,
        archiveModalOpened,
        setArchiveModalOpened,
    };
}

function computeArchiveToolState(
    t: TFunction,
    hasSelection: boolean,
    hasArchivedSelection: boolean
): TextToolState {
    if (!hasSelection) {
        return {
            type: "DISABLED",
            reason: t("TestingActivities_ArchiveNoSelection"),
        };
    }
    // Already-archived activities can not be archived again
    if (hasArchivedSelection) {
        return {
            type: "DISABLED",
            reason: t("TestingActivities_Archive_AlreadyArchived"),
        };
    }
    return { type: "ENABLED" };
}
